import { render } from "./TheAlert.vue?vue&type=template&id=4634066c&scoped=true"
import script from "./TheAlert.vue?vue&type=script&lang=js"
export * from "./TheAlert.vue?vue&type=script&lang=js"

import "./TheAlert.vue?vue&type=style&index=0&id=4634066c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4634066c"]])

export default __exports__